/**
 * Klaviyo back in stock: the "Notify Me When Available" button.
 *
 * Carried over from the old theme's legacy onsite integration. Klaviyo's
 * onsite.js binds to the hidden .klaviyo-bis-trigger anchor (rendered in
 * snippets/product-add-to-cart.liquid), re-reads the selected variant from the
 * URL (?variant=) or the form's hidden id input whenever a change event reaches
 * it, and shows or hides the button by its own out-of-stock rules. The Klaviyo
 * app embed's klaviyo.js does not do this on its own.
 *
 * Loading: layout/theme.liquid loads Klaviyo's onsite.js as a deferred script
 * immediately before this file, on product templates, and configuration runs
 * on DOMContentLoaded. This mirrors the old theme's timing exactly.
 *
 * Variant switches: the old theme wrote the URL and hidden input synchronously
 * on change, so Klaviyo followed the click instantly. Vision 17 writes both
 * only after fetching the re-rendered section, and the variant it announces on
 * its product:variant-change event is the PREVIOUS one (it reads a
 * server-rendered span that only refreshes with that fetch). So on the event
 * the selected variant is resolved here from the picked option values against
 * the product's variant list, and the URL and hidden input are written at once
 * in the theme's own format. The dispatched change event is what prompts
 * Klaviyo to re-evaluate. Visibility itself is left entirely to Klaviyo.
 */
(function () {
  var ACCOUNT = 'PSysvv';

  function configure() {
    var klaviyo = window.klaviyo;
    if (!klaviyo || typeof klaviyo.init !== 'function' || typeof klaviyo.enable !== 'function') return;
    klaviyo.init({ account: ACCOUNT, platform: 'shopify' });
    klaviyo.enable('backinstock', {
      trigger: {
        product_page_text: 'Notify Me When Available',
        product_page_class: 'button accent',
        product_page_text_align: 'center',
        product_page_margin: '0px',
        replace_anchor: false
      },
      modal: {
        headline: '{product_name}',
        body_content: 'Register to receive a notification when this item comes back in stock.',
        email_field_label: 'Email',
        button_label: 'Notify me when available',
        subscription_success_label: "You're in! We'll let you know when it's back.",
        footer_content: '',
        drop_background_color: '#000',
        background_color: '#fff',
        text_color: '#222',
        button_text_color: '#fff',
        button_background_color: '#434e3e',
        close_button_color: '#ccc',
        error_background_color: '#fcd6d7',
        error_text_color: '#C72E2F',
        success_background_color: '#d3efcd',
        success_text_color: '#1B9500'
      }
    });
  }

  /* ---- Variant list, loaded once per product ---- */
  var variantLists = {};

  function variantsFor(picker) {
    var url = picker.dataset.url;
    if (variantLists[url]) return variantLists[url];

    // The sticky bar's picker embeds product.variants as JSON; use it when present.
    var embedded = document.querySelector('variant-selects[data-sticky][data-section="' + picker.dataset.section + '"] script[type="application/json"]');
    if (embedded) {
      try {
        variantLists[url] = Promise.resolve(JSON.parse(embedded.textContent));
        return variantLists[url];
      } catch (e) { /* fall through to fetch */ }
    }
    // Otherwise fetch Shopify's product JSON (Klaviyo requests the same URL at
    // init, so this is normally served from the browser cache).
    variantLists[url] = fetch(url + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { return p ? p.variants : []; })
      .catch(function () { return []; });
    return variantLists[url];
  }

  function pickedOptions(picker) {
    var values = [];
    picker.querySelectorAll('fieldset').forEach(function (fieldset) {
      var select = fieldset.querySelector('select');
      var checked = fieldset.querySelector('input:checked');
      values.push(select ? select.value : (checked ? checked.value : null));
    });
    return values;
  }

  function matches(variant, values) {
    var opts = variant.options || [variant.option1, variant.option2, variant.option3].filter(function (o) { return o != null; });
    if (opts.length !== values.length) return false;
    for (var i = 0; i < values.length; i++) {
      if (String(opts[i]) !== String(values[i])) return false;
    }
    return true;
  }

  document.addEventListener('product:variant-change', function (e) {
    var section = e.detail && e.detail.sectionId;
    if (!section) return;
    var picker = document.querySelector('variant-selects[data-section="' + section + '"]:not([data-sticky])');
    if (!picker) return;
    var values = pickedOptions(picker);

    variantsFor(picker).then(function (variants) {
      var variant = null;
      for (var i = 0; i < variants.length; i++) {
        if (matches(variants[i], values)) { variant = variants[i]; break; }
      }
      if (!variant) return; // unavailable combination: the theme handles that state

      if (picker.dataset.updateUrl !== 'false' && picker.dataset.url) {
        window.history.replaceState({}, '', picker.dataset.url + '?variant=' + variant.id);
      }
      var input = document.querySelector('#product-form-' + section + ' input[name="id"]');
      if (input && input.value !== String(variant.id)) {
        input.value = variant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', configure);
  } else {
    configure();
  }
})();
